
export default function (countryCode) {
  let phonePrefix = ''
  let samplePhoneNumber = ''
  switch (countryCode) {
    case 'CL':
      phonePrefix = '+56'
      samplePhoneNumber = '+56 9 0000 0000'
      break
    case 'PE':
      phonePrefix = '+51'
      samplePhoneNumber = '+51 9 00 000 000'
      break
    case 'AR':
      phonePrefix = '+54'
      samplePhoneNumber = '+54 9 000 000 0000'
      break
    case 'MX':
      phonePrefix = '+52'
      samplePhoneNumber = '+52 1 1111 1111'
      break

    default:
      phonePrefix = '+56'
      samplePhoneNumber = '+56 9 0000 0000'
      break
  }

  return {
    phonePrefix,
    samplePhoneNumber
  }
}
